export default (toast) => ({
    toast,

    removeToast() {
        setTimeout(() => {
            this.$el.remove();
        }, 300); // Tiempo para la transición de salida
    },
});
